import { render, staticRenderFns } from "./jsonRender.vue?vue&type=template&id=185348cc&scoped=true&"
import script from "./jsonRender.vue?vue&type=script&lang=js&"
export * from "./jsonRender.vue?vue&type=script&lang=js&"
import style0 from "./jsonRender.vue?vue&type=style&index=0&id=185348cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185348cc",
  null
  
)

export default component.exports